import React, { useState } from 'react';
import { formatToCurrency } from '../Tools/formatToCurrency';

const AmountInput = ({
  value = '',
  onChange = (e) => {},
  ...props
}) => {
  const [prevValue, setPrevValue ] = useState('');

  const evaluateValue = (e) =>
  {
    let pattern = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/;
    const isNumber = pattern.test(e.target.value);

    if(isNumber || e.target.value === "")
    {
      setPrevValue(e.target.value);
      onChange(e.target.value);
    }
    else
    {
      onChange(prevValue);
    }
  }
	
  return (
    <input 
      type='text'
      value={value}
      onChange={evaluateValue}
      onKeyPress={evaluateValue}
      {...props}
    />
  );
}

export default AmountInput;
